import { z } from "zod";

export enum ScheduleCandidateSignal {
    revenueAmount = "revenue_amount",
    memo = "memo",
    repeatCustomer = "repeat_customer",
    invoiceTerm = "invoice_term",
    expenseAmount = "expense_amount",
    expenseMemo = "expense_memo",
}

export enum ScheduleCandidateKind {
    invoice = "invoice",
    payment = "payment",
}

export const SCHEDULE_CANDIDATES_DEFAULT_LIMIT = 25;
export const SCHEDULE_CANDIDATES_MAX_LIMIT = 100;

export const listScheduleCandidatesQuerySchema = z.object({
    entityId: z.coerce.number().int().positive(),
    kind: z.nativeEnum(ScheduleCandidateKind).optional(),
    customerId: z.string().uuid().optional(),
    since: z.string().date().optional(),
    until: z.string().date().optional(),
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(SCHEDULE_CANDIDATES_MAX_LIMIT)
        .default(SCHEDULE_CANDIDATES_DEFAULT_LIMIT),
    offset: z.coerce.number().int().min(0).default(0),
});
export type ListScheduleCandidatesQuery = z.infer<
    typeof listScheduleCandidatesQuerySchema
>;

export const scheduleCandidateRecognitionSchema = z.object({
    applicationId: z.string().uuid(),
    templateId: z.string().uuid(),
    templateName: z.string(),
});

export const scheduleCandidateSchema = z.object({
    kind: z.nativeEnum(ScheduleCandidateKind),
    transactionId: z.number().int().nullable(),
    invoiceId: z.string().uuid().nullable(),
    paymentTransactionIds: z.array(z.number().int()),
    dateOnly: z.string().nullable(),
    amount: z.number(),
    customerId: z.string().uuid().nullable(),
    customerName: z.string().nullable(),
    signals: z.array(z.nativeEnum(ScheduleCandidateSignal)),
    counterpartRecognition: scheduleCandidateRecognitionSchema.nullable(),
});
export type ScheduleCandidate = z.infer<typeof scheduleCandidateSchema>;

export const listScheduleCandidatesResponseSchema = z.object({
    candidates: z.array(scheduleCandidateSchema),
    total: z.number().int().nonnegative(),
});
export type ListScheduleCandidatesResponse = z.infer<
    typeof listScheduleCandidatesResponseSchema
>;
